import { Box, Typography } from '@mui/material';
import React from 'react';

import { fontFeatureSettings, palette, spaces } from '../../../assets/styles/themes/tokens';

interface AIToolsFormHeaderProps {
	title: string;
	description: string;
}

const containerStyles = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
	gap: spaces.sm,
	alignSelf: 'stretch',
};

const titleStyles = {
	color: palette.text.primary,
	fontFeatureSettings: fontFeatureSettings.disableLigatures,
};

const descriptionStyles = {
	color: palette.text.primary,
	fontFeatureSettings: fontFeatureSettings.disableLigatures,
};

const AIToolsFormHeader: React.FC<AIToolsFormHeaderProps> = ({ title, description }) => {
	return (
		<Box sx={containerStyles}>
			<Typography variant="h6" sx={titleStyles}>
				{title}
			</Typography>
			<Typography variant="caption" sx={descriptionStyles}>
				{description}
			</Typography>
		</Box>
	);
};

export default AIToolsFormHeader;
